// extracted by mini-css-extract-plugin
module.exports = {"productPrice":"_1-tXV","secondary":"_2u-Nz","crossed":"_1pacW"};